import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { ThemeContextProvider } from './theme/ThemeContextProvider';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ThemeContextProvider>
  <BrowserRouter>
    <App/>
  </BrowserRouter>
  </ThemeContextProvider>);
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
